import { AttachedFilePermissionItemDto, AttachedFilePermissionType, AttachedFilePrivateType, AttachedFileWithPermissionsDto, ClientLocal, PermissionType, UserDto, UserGroupWithDetailsDto } from 'models/index';
//import useClient from './useClient';

function getHighestPermission(permissions: AttachedFilePermissionItemDto[], userId: number, userGroupIds: number[]): AttachedFilePermissionType {
    var applicablePermissionItems = permissions.filter(x => x.user?.id == userId || userGroupIds.indexOf(x.userGroup?.id ?? -1) >= 0);

    if (applicablePermissionItems.find(x => x.type == AttachedFilePermissionType.Owner)) {
        return AttachedFilePermissionType.Owner;
    }
    if (applicablePermissionItems.find(x => x.type == AttachedFilePermissionType.ReadWrite)) {
        return AttachedFilePermissionType.ReadWrite;
    }
    if (applicablePermissionItems.find(x => x.type == AttachedFilePermissionType.ReadOnly)) {
        return AttachedFilePermissionType.ReadOnly;
    }

    return null;
}
function hasPermission(permissions: AttachedFilePermissionItemDto[], type: AttachedFilePermissionType, userId: number, userGroupIds: number[]): boolean {
    var highestApplicablePermission = getHighestPermission(permissions, userId, userGroupIds);

    if (highestApplicablePermission == null)
        return false;

    if (type == AttachedFilePermissionType.ReadOnly) {
        return true;
    }
    if (type == AttachedFilePermissionType.ReadWrite) {
        return highestApplicablePermission == AttachedFilePermissionType.ReadWrite ||
            highestApplicablePermission == AttachedFilePermissionType.Owner;
    }
    if (type == AttachedFilePermissionType.Owner) {
        return highestApplicablePermission == AttachedFilePermissionType.Owner;
    }

    return false;
}

interface IGlobalContext {
    getUser: () => UserDto;
    getCompanyLocal: () => ClientLocal;
    getUserGroups: () => UserGroupWithDetailsDto[];
    getUserGroupIds: () => number[];

    setUser: (item: UserDto) => void;
    setCompanyLocal: (item: ClientLocal) => void;
    setUserGroups: (item: UserGroupWithDetailsDto[]) => void;
    setUserGroupIds: (item: number[]) => void;
}

export let globalUser: UserDto = null;
export let globalCompanyLocal: ClientLocal = null;
export let globalUserGroups: UserGroupWithDetailsDto[] = null;
export let globalUserGroupIds: number[];

let globalContext: IGlobalContext = {
    getUser: () => globalUser,
    setUser: (item) => globalUser = item,
    getCompanyLocal: () => globalCompanyLocal,
    setCompanyLocal: (item) => globalCompanyLocal = item,
    getUserGroups: () => globalUserGroups,
    setUserGroups: (item) => globalUserGroups = item,

    getUserGroupIds() {
        return globalUserGroupIds;
    },
    setUserGroupIds(item) {
        globalUserGroupIds = item;
    },
};

export default globalContext;

export function userHasPermission(requestedPermission: PermissionType, user?: UserDto, client?: ClientLocal): boolean {
    user = user ?? globalContext.getUser();
    client = client ?? globalContext.getCompanyLocal();

    const localPermission = client.userPermissions[user.id];
    if (!localPermission)
        return false;
    if (localPermission.isInstanceAdmin)
        return true;

    const index = localPermission.permissions.findIndex(x => x == requestedPermission);
    if (index >= 0)
        return true;

    return false;
}
function userGetGroups(user?: UserDto): UserGroupWithDetailsDto[] {
    user = user ?? globalContext.getUser();
    return globalContext.getUserGroups().filter(x => x.users.findIndex(y => y.id == user.id) > 0);
}
export function userGetGroupIds(user?: UserDto): number[] {
    return userGetGroups(user ?? globalContext.getUser()).map(x => x.id);
}
function isViewableBy(file: AttachedFileWithPermissionsDto, userId?: number, userGroupIds?: number[]): boolean {
    if (userHasPermission(PermissionType.Admin))
        return true;

    if (!userHasPermission(PermissionType.FilArkiv))
        return false;

    if (file.isPrivate == null)
        return true;
    if (file.isPrivate == AttachedFilePrivateType.None || file.isPrivate == AttachedFilePrivateType.WriteOnly)
        return true;

    if (file.permissions == null)
        throw new Error(`Permission is null. FileId=${file.id}.`);

    userId = userId ?? globalUser.id;
    userGroupIds = userGroupIds ?? globalUserGroupIds;

    return hasPermission(file.permissions.items, AttachedFilePermissionType.ReadOnly, userId, userGroupIds);
}
export function isWriteableBy(file: AttachedFileWithPermissionsDto, userId?: number, userGroupIds?: number[]): boolean {
    if (userHasPermission(PermissionType.Admin))
        return true;

    if (!userHasPermission(PermissionType.FilArkiv))
        return false;

    if (file.isPrivate == null)
        return true;
    if (file.isPrivate == AttachedFilePrivateType.None)
        return true;

    if (file.permissions == null)
        throw new Error(`Permission is null. FileId=${file.id}.`);

    userId = userId ?? globalContext.getUser().id;
    userGroupIds = userGroupIds ?? globalUserGroupIds;

    return hasPermission(file.permissions.items, AttachedFilePermissionType.ReadWrite, userId, userGroupIds);
}
